module.exports = __webpack_public_path__ + "static/img/legend_xa_english_dark_vertical.ef35dde.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/legend_xa_english_dark_vertical.png
// module id = PoPW
// module chunks = 79